enum LineItemPropertyKeys {
  CURATED_DEAL_ID = 'curated-deal-id',
  DEAL_ID = 'deal-id',
  DEAL_ID_SSP = 'deal-id-ssp',
  DEAL_IDS = 'deal-ids',
  DEAL_IDS_BY_MEDIAOWNER = 'deal-ids-by-mediaowner',
  DEAL_IDS_BY_SSP = 'deal-ids-by-ssp',
  FROM_CURATED_DEAL = 'from-curated-deal',
  MIN_BID_CPM = 'min_bid_cpm',
  MOBILE_RETARGETING = 'mobile_retargeting',
  FREQUENCY_CAP_EXPOSURE_COUNT = 'frequency_cap_exposure_count',
  FREQUENCY_CAP_EXPOSURE_PER_UNIT = 'frequency_cap_exposure_per_unit',
  FREQUENCY_CAP_EXPOSURE_PER_UNIT_COUNT = 'frequency_cap_exposure_per_unit_count',
}

export default LineItemPropertyKeys;
